export default {
  sqlDatabase: 'Base de données SQL',
  goBack: 'Retourner à la page précédente',
  title: 'Une erreur inattendue est apparue',
  subTitle: 'Veuillez réessayer.',
  message: 'Si le problème persiste, veuillez contacter le support technique.',
};
